import React from 'react';
import './DashboardCommonSection.scss';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const DashboardCommonSection = (props) => {
  const {t} = useTranslation();

  return (
    <section className="tips-box-section bg-blue-2" data-testid="DashboardCommonSection" aria-labelledby="tips-box-title">
      <div className="container">
        <div className="tips-box__content">
          <div className="tips-box__content-container">
            <div className="tips-box__content-container-icon">
              <div className="tips-box__icon">
                <i className={props.icon}>
                <span className="path1"/><span className="path2"/></i>
              </div>
            </div>
            <div className="tips-box__content-container-text">
              <h2 className="tips-box__content-text--title headline-bold-fs3">{props.title}</h2>
              <p className="tips-box__content-text--description headline-fs6">{props.description}</p>
            </div>
          </div>
          <div className="tips-box__content-cta">
            {props.externalLink ? (
              <a className="btn btn-secondary btn-icon btn-icon-right" href={props.link} target="_blank" rel="noopener" aria-describedby="tips-box-title">
                {props.btnTitle ? props.btnTitle : t("common.active")}
                { props.ctaSrOnly ?(
                <span className="sr-only">{props.ctaSrOnly}</span>
                ):
                null
                }
                <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
              </a>
            ) : ( <Link to={props.link} className="btn btn-secondary btn-icon btn-icon-right" onClick={() => window.dataLayer.push({event:"domiciliazioneBancariaIniziata"})} aria-describedby="tips-box-title">
                {props.btnTitle ? props.btnTitle : t("common.active")}
                { props.ctaSrOnly ?(
                <span className="sr-only">{props.ctaSrOnly}</span>
                ):
                null
                }
                <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i></Link>)}
          </div>
        </div>
      </div>
    </section>
  )
};
export default DashboardCommonSection;
